import * as Sentry from '@sentry/react'
import { getEnvs } from 'utils/envs'
// import { enableSentryReplay } from './replay'
// import { getReplayIntegration } from './replay'
const { SENTRY_DSN, SENTRY_ENV } = getEnvs()

const allowedEnvironments = ['production', 'staging', 'development']

const excludedErrors = [
  'Uncaught (in promise) AbortError: The play() request was interrupted because video-only background media was paused to save power.'
]

Sentry.init({
  dsn: SENTRY_DSN,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  beforeSend: (event, hint) => {
    if (hint.originalException instanceof Error) {
      if (excludedErrors.includes(hint.originalException.message)) {
        return null
      }
    }
    return event
  },
  tracesSampleRate: 1,
  // Session Replay
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: SENTRY_ENV,
  enabled: allowedEnvironments.includes(SENTRY_ENV)
})

// enableSentryReplay()
